// QA

// export const EvironmentAPI = {
//     isPRD: false,
//     web_rep_url: 'http://vivo-dev-node.focustextil.loc.br:1037/',
//     api: 'http://vivo-dev-node.focustextil.loc.br:1037/api/v2/versions',// QA
//     download_app_ios: 'itms-services://?action=download-manifest&url=https://www.focustextil.com.br/apps/ifair/development/ios/iFair.plist',
//     download_app_android: 'https://play.google.com/apps/internaltest/4700941820984429631',
//     catalogo: "http://dev-institucional.focustextil.loc.br/catalogo/",
//     efocus: "http://dev-institucional.focustextil.loc.br/efocus-dev/",
//     boleto: "http://dev-institucional.focustextil.loc.br/boleto/",
//     pedidos: "http://dev-institucional.focustextil.loc.br/pedidos/",
//     webrep: "http://vivo-dev-node.focustextil.loc.br:1037/",
//     appstore: "http://dev-institucional.focustextil.loc.br/site/#/appstore",
//     service_mail: "https://qa-nodejs.focustextil.com.br/mailer-services/send",
//     instagram_api: "https://dev-iis-es.focustextil.com.br/instagram-services/instagram",
//     heter_link: "http://dev-institucional.focustextil.loc.br/HETER_IKSA.PDF"
// }

// PRD

export const EvironmentAPI = {
  isPRD: true,
  web_rep_url: "https://webrep2.focustextil.com.br/",
  api: "https://webrep2.focustextil.com.br/api/v2/versions", // PRD - Sempre comentar PRD quando for para QA
  download_app_ios:
    "itms-services://?action=download-manifest&url=https://www.focustextil.com.br/apps/ifair/production/ios/iFair-prod.plist",
  download_app_android:
    "https://www.focustextil.com.br/apps/ifair/production/android/iFair-prod.apk",
  catalogo: "https://www.focustextil.com.br/catalogo/",
  efocus: "https://efocus.focustextil.com.br/",
  boleto: "https://www.focustextil.com.br/boleto/",
  pedidos: "https://www.focustextil.com.br/pedidos/",
  webrep: "https://webrep2.focustextil.com.br/",
  appstore: "https://www.focustextil.com.br/site/#/appstore",
  instagram_api: "https://www.focustextil.com.br/instagram-services/instagram",
  service_mail: "https://www.focustextil.com.br/mailer-services/send",
  heter_link: "https://www.focustextil.com.br/HETER_ISKA.pdf",
};
